import React from 'react'
import {
    Row,
    Col,
    Button,
    CardImg,
    CardHeader,
    CardBody,
    CardFooter,
    Card,
} from 'reactstrap'
import { withTranslation } from 'react-i18next'
import api from '../../api/api'
import { processError } from '../../lib/lib'
import NewsModal from '../../components/News/NewsModal'
import Cookies from 'universal-cookie'
import PropTypes from 'prop-types'
import { ShareNetwork, ArrowSquareLeft } from "phosphor-react"
import Skeleton from '../../components/UI/Skeleton'
const cookies = new Cookies()

class PageDesc extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            pageInfo: {
                title: '',
                date: '',
                image: '',
                content: '',
            },
            showModal: false,
            pageInfoLoaded: false,
            dataLoaded: false,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
    }

    getPageInfo(uri, lang, token) {
        return new Promise((resolve, reject) => {
            api.getPageInfo(uri, lang, token)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    async componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        let arrPromise = [
            this.getPageInfo(this.props.match.params.uri, lang, token).then((pageInfo) => this.setState({ pageInfo, pageInfoLoaded: true })),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    routeTo(link) {
        this.props.history.push(`/${link}`)
    }

    render() {
        const { t } = this.props
        // const propsState = this.props.location.state
        return (
            <Row className="bg-grey w-100 m-0 news-desc-content">
                <Col xl={12} className="p-0">
                    <Card className="news-desc-img">
                        <CardHeader className="pt-0">
                            {
                                this.state.pageInfoLoaded ?
                                    <React.Fragment>
                                        <CardImg src={this.state.pageInfo.image ? `${this.state.imageUrl}/${this.state.pageInfo.image}` : "data:,"} alt="" />
                                        <div className="link-title md-font-size">
                                            <span className="link" ></span>
                                            <span className="white"> </span>
                                        </div>
                                        <div className="img-text">
                                            <div className="type md-font-size"></div>
                                            <div className="title xxl-font-size">{this.state.pageInfo.title}</div>
                                        </div>
                                    </React.Fragment>
                                    :
                                    <Skeleton height={400} />
                            }
                        </CardHeader>
                    </Card>
                </Col>
                <Col xl={12} className="px-30">
                    <Row>
                        <Col lg={8} xl={8} className="main-content news-desc-display">
                            <Card className="custom-card h-100 d-flex">
                                <CardBody className="p-0">
                                    {
                                        this.state.pageInfoLoaded ?
                                            <React.Fragment>
                                                <div className="event-subtitle pt-0 xl-font-size" dangerouslySetInnerHTML={{ __html: this.state.pageInfo.desc }}></div>
                                                <div className="news-desc md-font-size" dangerouslySetInnerHTML={{ __html: this.state.pageInfo.content }}></div>
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                <div className="event-subtitle pt-0 xl-font-size">
                                                    <Skeleton count={2} />
                                                </div>
                                                <div className='news-desc md-font-size p-0 my-20px'>
                                                    <Skeleton count={5} />
                                                </div>
                                            </React.Fragment>
                                    }
                                </CardBody>
                                <CardFooter className="d-flex justify-content-between align-items-center p-0 flex-wrap mt-auto">
                                    {
                                        this.state.dataLoaded ?
                                            <React.Fragment>
                                                <Button type="button" className="btn profile-avatar-btn primary watch-all" onClick={() => this.routeTo(`main`)}>
                                                    <ArrowSquareLeft size={20} />
                                                    <span className="pl-5px sm-font-size">{t('news-back')}</span>
                                                </Button>
                                                <Button type="button" className="btn profile-avatar-btn grey watch-all" onClick={() => this.setState({ showModal: !this.state.showModal })}>
                                                    <ShareNetwork size={20} />
                                                    <span className="pl-5px sm-font-size">{t('news-share')}</span>
                                                </Button>
                                            </React.Fragment>
                                            :
                                            <div className='d-flex justify-content-between w-100'>
                                                <Skeleton className="watch-all" width={250} />
                                                <Skeleton className="watch-all" width={250} />
                                            </div>
                                    }
                                    {
                                        this.state.showModal &&
                                        <NewsModal
                                            showModal={this.state.showModal}
                                            toggle={() => this.setState({ showModal: !this.state.showModal })}
                                        />
                                    }
                                </CardFooter>
                            </Card>
                        </Col >
                    </Row>
                </Col>
            </Row >
        )
    }
}

PageDesc.propTypes = {
    match: PropTypes.object,
    i18n: PropTypes.object,
    t: PropTypes.func,
    history: PropTypes.object,
    location: PropTypes.object,
}

export default withTranslation()(PageDesc)



// WEBPACK FOOTER //
// ./src/views/Pages/PageDesc.jsx